import React from "react";
import { useNavigate } from "react-router-dom";

const CTA = ({
  title = "چگونه مشاوره‌ی لانجویتی را شروع کنم؟",
  className = "max-w-5xl mx-auto flex justify-between items-center max-md:flex-col max-md:bg-gradient-to-b bg-gradient-to-l to-blue-600  from-bgBlue p-6 rounded-lg shadow-md  shadow-bgBlue",
}) => {
  const navigate = useNavigate();
  return (
    <section className=" h-auto   p-6 mt-6">
      <div className={className}>
        <div className="flex flex-col items-start max-md:items-center">
          <h2 className=" font-bold text-lg text-white mb-4">{title}</h2>
          <p className=" text-gray-200">
            با پر کردن فرم ارزیابی می‌توانید، فرایند مشاوره‌ی لانجویتی را شروع
            کنید.{" "}
          </p>
        </div>
        <button
          className=" bg-gradient-to-t to-slate-50  from-slate-300 text-md   text-bgBlue px-4  py-2 w-fit rounded-lg flex items-center gap-2 cursor-pointer group max-md:mt-8 max-md:mx-auto font-bold hover:scale-105 transition-all duration-300  "
          onClick={() => navigate("/form")}
        >
          <span className=" mx-auto">تکمیل فرم ارزیابی</span>
        </button>
      </div>
    </section>
  );
};

export default CTA;
